import { useToken } from "@gluestack-style/react";
import { Box, Button, HStack, Input, InputField, Text, Typography } from "components/ui";
import { useRouter } from "expo-router";
import { Formik } from "formik";
import { AlertCircle } from "lucide-react-native";
import React from "react";
import { Toast } from "react-native-toast-notifications";
import { GroupRole, usePostCatalogueMutation, usePostTemplateMutation } from "store/abcoApi";
import * as Yup from "yup";

interface SiteCatalogueFormProps {
	groupRole?: GroupRole | null | undefined;
	isNew?: boolean;
	closePopupModal?: () => void;
	type?: "catalogue" | "template" | "create-catalogue";
	siteId?: string | number;
	catalogue?: {
		id?: number;
		name?: string;
		isDeleted?: boolean;
	} | null;
}

export default function SiteCatalogueForm({ catalogue = null, siteId, isNew = true, closePopupModal, type = "catalogue" }: SiteCatalogueFormProps) {
	const resolvedErrorBright = useToken("colors", "errorbright");
	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Name is required").min(3, "Name must be at least 3 characters"),
	});
	const [errorMessages, setErrorMessages] = React.useState<string>("");
	const [postTemplate, { isLoading: isSaving2 }] = usePostTemplateMutation();
	const [postCatalogue, { isLoading: isSaving }] = usePostCatalogueMutation();
	//const [putRole, { isLoading: isUpdating }] = usePutCaByIdMutation();
	const router = useRouter();

	const doPost = async (values: any) => {
		if (type === "catalogue") {
			return await postCatalogue({
				stockCollection: values,
			}).unwrap();
		} else {
			return await postTemplate({
				stockCollection: values,
			}).unwrap();
		}
	};

	const InputError = ({ text }: { text: string }) => {
		return (
			<HStack gap={6} py={6}>
				<AlertCircle color={resolvedErrorBright} />
				<Typography.ParagraphSmall sx={{ color: "$errorbright" }}>{text}</Typography.ParagraphSmall>
			</HStack>
		);
	};

	return (
		<Box>
			<Formik
				initialValues={{
					id: catalogue?.id ?? 0,
					name: catalogue?.name ?? "",
					isDeleted: catalogue?.isDeleted ?? false,
				}}
				onSubmit={async (values) => {
					if (isNew) {
						try {
							const response = await doPost(values).then((response) => {
								if (response.id) {
									if (type === "catalogue") {
										return router.push(`/admin/catalogues/${response.id}`);
									} else {
										return router.push(`/admin/stocklists/${response.id}`);
									}
								}
								Toast.show("Created catalogue successfully", {
									type: "success",
									textStyle: { fontSize: 20 },
									placement: "bottom",
								});
								if (closePopupModal) {
									closePopupModal();
								}
							});
						} catch (error) {
							console.error("Error creating role:", error);
						}
					} else {
						try {
							// console.log("Updating role", values);
							// const response = await putRole({ id: groupRole?.id ?? 0, groupRole: values }).unwrap();
							// if (response.id) {
							// 	router.push(`/admin/catalogues/${response.id}`);
							// }
						} catch (error) {
							console.error("Error updating role:", error);
						}
					}
				}}
			>
				{({ handleChange, handleBlur, handleSubmit, values, errors, touched }) => (
					<Box gap={20}>
						<Box gap={6}>
							<Text sx={{ fontFamily: "$robotoBold" }}>Name</Text>
							<Input padding={12} borderRadius={8} variant="outline" size="md">
								<InputField onChangeText={handleChange("name")} onBlur={handleBlur("name")} value={values.name ?? ""} placeholder="Contract XYZ" />
							</Input>
							{errors.name && touched.name && <InputError text={errors.name} />}
						</Box>

						<Button mt={20} variant="secondary" onPress={handleSubmit} disabled={isSaving || isSaving2}>
							{isNew ? <Text>{isSaving || isSaving2 ? "Saving..." : "Create"}</Text> : null}
						</Button>
					</Box>
				)}
			</Formik>
		</Box>
	);
}
